import { render } from "./ReleaseNoteForm.vue?vue&type=template&id=7cbdef2f"
import script from "./ReleaseNoteForm.vue?vue&type=script&lang=js"
export * from "./ReleaseNoteForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__